function getTips(label: string) {
    switch (label) {
        case 'PPS':
            return 'Profit Per Subscription';
        case 'PPT':
            return 'Profit Per Trial';
        case 'ICR':
            return 'Install CR';
        case 'TCR':
            return 'Trial CR';
        case 'SCR':
            return 'Subscription CR';
        default:
            return label;
    }
}

export default getTips;